var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86536 19.7079C4.40229 19.7079 4.01034 19.5474 3.6895 19.2266C3.36867 18.9058 3.20825 18.5138 3.20825 18.0508V5.78163C3.20825 5.31856 3.36867 4.92661 3.6895 4.60578C4.01034 4.28494 4.40229 4.12453 4.86536 4.12453H6.13448V2.18555H7.54477V4.12453H14.4904V2.18555H15.8654V4.12453H17.1345C17.5976 4.12453 17.9895 4.28494 18.3103 4.60578C18.6312 4.92661 18.7916 5.31856 18.7916 5.78163V18.0508C18.7916 18.5138 18.6312 18.9058 18.3103 19.2266C17.9895 19.5474 17.5976 19.7079 17.1345 19.7079H4.86536ZM4.86536 18.3329H17.1345C17.2051 18.3329 17.2697 18.3034 17.3284 18.2446C17.3872 18.186 17.4166 18.1213 17.4166 18.0508V9.4483H4.58325V18.0508C4.58325 18.1213 4.61266 18.186 4.67148 18.2446C4.73015 18.3034 4.79477 18.3329 4.86536 18.3329Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.194379e1772b7e05b672bd28ff139c77.svg";
export { ForwardRef as ReactComponent };